import { render, staticRenderFns } from "./registerMerchant.vue?vue&type=template&id=efb6a1e8&scoped=true"
import script from "./registerMerchant.vue?vue&type=script&lang=js"
export * from "./registerMerchant.vue?vue&type=script&lang=js"
import style0 from "./registerMerchant.vue?vue&type=style&index=0&id=efb6a1e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb6a1e8",
  null
  
)

export default component.exports